import { render, staticRenderFns } from "./AddPriceProductModal.vue?vue&type=template&id=437c8382&scoped=true&"
import script from "./AddPriceProductModal.vue?vue&type=script&lang=js&"
export * from "./AddPriceProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437c8382",
  null
  
)

export default component.exports